'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _browserApi = require('../../shared/browserApi');

var _mapApi = require('../../shared/mapApi');

var _FormTextfield = require('../FormTextfield/FormTextfield');

var _FormTextfield2 = _interopRequireDefault(_FormTextfield);

var _ButtonTooltip = require('../ButtonTooltip/ButtonTooltip');

var _ButtonTooltip2 = _interopRequireDefault(_ButtonTooltip);

require('./SearchBlock.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developers.google.com/maps/documentation/geocoding/intro?hl=fr#Types
var types = ['street_address', 'route', 'intersection', 'neighborhood', 'premise', 'subpremise', 'point_of_interest'];

var SearchBlock = function (_Component) {
  (0, _inherits3.default)(SearchBlock, _Component);

  function SearchBlock() {
    (0, _classCallCheck3.default)(this, SearchBlock);
    return (0, _possibleConstructorReturn3.default)(this, (SearchBlock.__proto__ || (0, _getPrototypeOf2.default)(SearchBlock)).apply(this, arguments));
  }

  (0, _createClass3.default)(SearchBlock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.searchValue) {
        (0, _mapApi.geocode)(this.props.api, this.props.searchValue, true).then(function (_ref) {
          var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
              location = _ref2[0],
              point = _ref2[1];

          return _this2.search(point);
        });
      }

      this.loadCallback = function () {
        return _this2.props.geolocateOnLoad && _this2.geolocate();
      };
      window.addEventListener('load', this.loadCallback);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.loadCallback);
    }
  }, {
    key: 'onAutocomplete',
    value: function onAutocomplete(value) {
      var _this3 = this;

      (0, _mapApi.geocode)(this.props.api, value, true).then(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            location = _ref4[0],
            point = _ref4[1];

        _this3.props.setCurrentAddress(location);
        _this3.search(point, true);
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      this.props.setCurrentAddress(value);
    }
  }, {
    key: 'geolocate',
    value: function geolocate(event) {
      var _this4 = this;

      event && event.preventDefault();
      (0, _browserApi.geolocate)(this.props.api).then(function (point) {
        _this4.props.search(null, point);
        return (0, _mapApi.geocode)(_this4.props.api, point);
      }).then(function (_ref5) {
        var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
            location = _ref6[0],
            point = _ref6[1];

        return _this4.props.setCurrentAddress(location);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var __ = this.props.__;
      var addonAfter = _react2.default.createElement('span', {
        'aria-label': __('SearchBlock|Search'),
        className: 'icon icon-search',
        style: { fontSize: 18, lineHeight: '38px' }
      });

      return _react2.default.createElement(
        'div',
        { className: 'SearchBlock', style: this.props.style },
        _react2.default.createElement(
          'div',
          { className: 'SearchBlock__btns' },
          _react2.default.createElement(
            'div',
            { className: 'SearchBlock__field' },
            _react2.default.createElement(_FormTextfield2.default, {
              addonAfter: addonAfter,
              addonAfterSubmit: true,
              api: this.props.api,
              autocomplete: true,
              name: 'search',
              onChange: this.onChange.bind(this),
              placeholder: this.props.placeholder || __('SearchBlock|Search'),
              fullWidth: true,
              submitCallback: this.onAutocomplete.bind(this),
              value: this.props.fieldValue,
              ariaLabel: __('SearchBlock|Search')
            })
          ),
          this.props.isGeolocationAvailable && _react2.default.createElement(
            _ButtonTooltip2.default,
            {
              className: 'SearchBlock__locate button button--light',
              'aria-label': __('SearchBlock|Geolocation'),
              onClick: this.geolocate.bind(this) },
            _react2.default.createElement(
              'span',
              { className: 'SearchBlock__locate-icon icon icon-geoloc' },
              ' '
            )
          )
        )
      );
    }
  }, {
    key: 'search',
    value: function search(place) {
      var userAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if ((0, _mapApi.isGMap)(this.props.api)) {
        if (place.geometry) {
          var location = void 0;
          if (R.intersection(place.types, types).length) {
            location = place.geometry.location;
          }
          this.props.search(place.geometry.viewport, location, userAction);
        }
      } else {
        this.props.search(null, place, userAction);
      }
    }
  }]);
  return SearchBlock;
}(_react.Component);

SearchBlock.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  api: _propTypes2.default.object,
  fieldValue: _propTypes2.default.string,
  geolocateOnLoad: _propTypes2.default.bool,
  isGeolocationAvailable: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  search: _propTypes2.default.func,
  searchValue: _propTypes2.default.string,
  selectedId: _propTypes2.default.string,
  setCurrentAddress: _propTypes2.default.func,
  style: _propTypes2.default.object
};

SearchBlock.defaultProps = {
  api: null,
  fieldValue: '',
  geolocateOnLoad: true,
  placeholder: '',
  search: function search() {},
  searchValue: '',
  selectedId: null,
  setCurrentAddress: function setCurrentAddress() {},
  style: {}
};

exports.default = (0, _reactTranslate.withTranslator)()(SearchBlock);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/SearchBlock/SearchBlock.js
// module id = 1174
// module chunks = 0